var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 66,
    viewBox: "0 0 161 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2707_29948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9822L4.69359 23.8362C8.05962 21.7378 11.3914 19.6908 14.6032 17.7551C18.0121 15.6396 20.5131 14.2007 22.2603 13.3527L22.346 13.3099H23.1168L23.1339 13.7296C23.2196 16.0164 23.2196 18.8257 23.2196 22.0804V30.063C23.2196 39.7328 23.1254 47.3642 23.0483 52.2633C23.014 54.6958 22.9798 56.7599 22.9455 58.4472C22.9112 60.3915 22.8855 61.8475 22.877 62.7896H36.5466C36.4696 60.991 36.3925 57.0597 36.3925 50.8587C36.3068 44.1951 36.3068 38.6022 36.3068 33.6688C36.3068 32.0415 36.3068 28.2301 36.3925 22.4316C36.4781 16.6845 36.5552 6.51791 36.5638 0.736572H23.4423C21.7036 1.85002 19.4767 3.29749 16.7616 5.079C11.2115 8.71911 5.52439 12.462 0 15.9822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1794 54.3617C80.9909 54.3617 80.8025 54.3874 80.6055 54.3874C77.9932 54.3874 75.6036 53.9421 73.5052 53.0684C71.244 52.1605 69.4025 50.9872 67.8866 49.4626C65.6083 47.27 63.8525 44.6063 62.8161 41.7713C61.8226 39.0305 61.2487 35.5445 61.2487 32.2042C61.2487 28.8639 61.8054 25.849 62.9018 22.8941C64.0495 19.8022 65.6168 17.3012 67.544 15.4512C69.0771 13.918 70.9614 12.6076 72.9741 11.6912C75.0212 10.7576 77.899 10.1923 80.6912 10.1923C83.4833 10.1923 85.8644 10.6377 88.0484 11.5113C90.1212 12.3421 91.9883 13.6011 93.7613 15.3741C95.9025 17.5153 97.4442 20.0334 98.4891 23.074C98.8146 23.9476 99.0715 24.8555 99.3028 25.7805L107.774 12.4192C106.806 11.143 105.735 9.92678 104.553 8.78764C101.547 5.95264 98.0266 3.76858 94.0782 2.28684C89.9499 0.770846 85.419 0 80.6141 0C75.8091 0 71.4153 0.805105 67.0643 2.45814C62.9446 4.05122 59.3901 6.3295 56.5123 9.21589C53.5231 12.128 51.2192 15.5625 49.6689 19.4339C48.1358 23.271 47.3906 27.4764 47.3906 32.2899C47.3906 37.1034 48.2214 41.4715 49.9258 45.5741C51.6303 49.6681 54.0627 53.1712 57.3602 56.306C60.3494 59.0382 63.8439 61.1366 67.7495 62.5498C70.1391 63.3978 72.4774 63.9802 74.8755 64.3313L81.1965 54.3617H81.1794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.193 65.265H137.853L101.023 7.28027L105.135 9.50716L107.764 12.4192L141.193 65.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.671 65.2649H146.331L107.352 3.92273H110.692L149.671 65.2649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.426 28.8639L116.868 39.4844L111.901 32.0329L90.4883 65.6932H111.215L134.426 28.8639Z",
    fill: "#BDF15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.549 1.61023H140.216L113.527 44.4521H124.747L133.055 31.519L138.28 38.7136L160.549 1.61023Z",
    fill: "#BDF15D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.521 47.8781L120.979 50.2763L104.363 23.468L106.162 20.9841L122.521 47.8781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.235 65.265H154.895L127.145 22.6115L129.029 19.6995L158.235 65.265Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2707_29948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.55,
    height: 65.6932,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0c0bbbf6b70a542b99cd190ba17b366e.svg";
export { ForwardRef as ReactComponent };